export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6993.9fc07f06.jpg";